



































import { Component, Vue } from 'vue-property-decorator';
import Api from '@/Api';

@Component
export default class KeyHire extends Vue {
    public datas: any = [];
    public show: boolean = false;

    public mounted() {
      Api.Instance
      .get('api/key-hire-data')
      .then((response) => {
        this.datas = response.data;
      });
    }
}
